import { ITrailer } from '../interfaces/ITrailer';
import { ITruck } from '../interfaces/ITruck';

export const needsService = (truck: ITruck) => {
  const thresholdKm = process.env.REACT_APP_THRESHOLD_KM;
  return truck.mileage >= truck.nextServiceKm - Number(thresholdKm);
};
export const needsAlarmSystemUpdate = (truck: ITruck) =>
  isDateDue(truck.alarmSystem, 1, 2);

export const needsTachographUpdate = (truck: ITruck) =>
  isDateDue(truck.tachograph, 1, 2);

export const needsTechInspection = (truck: ITruck | ITrailer) =>
  isDateDue(truck.technicalInspection, 1);

export const needsFrcInspection = (trailer: ITrailer) =>
  isDateDue(trailer.frc, 1, 2);

export const isDateDue = (
  dateStr: string,
  notifyBeforeMonths = 0,
  dueAfterYears = 1,
): boolean => {
  if (!dateStr) return false;

  const startDate = new Date(dateStr);

  const totalMonths = dueAfterYears * 12 - notifyBeforeMonths;

  const remindDate = new Date(startDate);
  remindDate.setMonth(remindDate.getMonth() + totalMonths);

  const now = new Date();

  return now >= remindDate;
};
